import type { ChatMessage } from '../../types';

/** Convert NovaX chat-only rich text markers without touching code examples. */
export function preprocessMarkdown(md: string): string {
  const parts = md.split(/(```[\s\S]*?```|`[^`]+`)/g);
  return parts.map((part, i) => {
    if (i % 2 === 1) return part;
    return part
      .replace(/::danger::(.*?)::/g, '<span class="nx-danger">$1</span>')
      .replace(/::success::(.*?)::/g, '<span class="nx-success">$1</span>')
      .replace(/::highlight::(.*?)::/g, '<span class="nx-highlight">$1</span>')
      .replace(/(?<![a-zA-Z0-9.])@([\w\p{L}\p{N}-]+)/gu, '<span class="nx-mention">@$1</span>');
  }).join('');
}

/** Message navigation is intentionally a user-prompt outline, not a transcript. */
export function getNavigationMessages(messages: ChatMessage[]): ChatMessage[] {
  return messages.filter((message) => message.type === 'user');
}

/**
 * Older uploads duplicated the attachment name into `text`. Hide only that
 * generated placeholder; genuine captions must remain visible beside files.
 */
export function getVisibleUserText(message: ChatMessage): string {
  const legacyAttachmentPlaceholder = message.attachments?.map((file) => file.name).join(', ') || '';
  return message.attachments?.length && message.text === legacyAttachmentPlaceholder ? '' : message.text;
}
